import { Resource } from "pages/EmailBuilder/EmailBuilder";
import { InclusionCriteria } from "pages/Group/MyGroup";

export enum GroupType {
  AUTOMATIC = "automatic",
  MANUAL = "manual",
}

export interface Group {
  id: string;
  name: string;
  inclusionCriteria: InclusionCriteria;
  isFreezed: boolean;
  isUpdating: boolean;
  resources: Resource[];
  type: GroupType;
  updatedAt?: string;
  createdAt?: string;
}
